import api from "../../client";
import {
  CreateContentBoxPayload,
  CreateContentBoxResponseData,
  ContentBoxSectionEnum,
} from "../../types/contentBox";

export const createProfileContentBoxRequest = async (
  section: ContentBoxSectionEnum,
  uuid: string | undefined,
  payload: CreateContentBoxPayload,
): Promise<CreateContentBoxResponseData> => {
  const { data } = await api.post<CreateContentBoxResponseData>(
    `/${section}/${uuid}/content-box`,
    payload,
  );

  return data;
};
